import { API } from "../utils";

export const getCustomers = async ({ params }) => {
  const response = API.get("/organization/customers", { params });
  const data = await response;
  return data;
};

export const getCustomersExcel = async ({ params }) => {
  const response = API.get("/organization/customers/excel/export", { params });
  const data = await response;
  return data;
};

export const createCustomer = async ({ body }) => {
  const response = API.post("/organization/customers", body);
  const data = await response;
  return data;
};

export const deleteCustomer = async ({ params }) => {
  const response = API.delete(`/organization/customers/${params.id}`, {
    params,
  });
  const data = await response;
  return data;
};

export const getSingleCustomer = async ({ params }) => {
  const response = API.get(`/organization/customers/${params.id}`, { params });
  const data = await response;
  return data;
};

export const updateCustomer = async ({ params, body }) => {
  const response = API.patch(`/organization/customers/${params.id}`, body);
  const data = await response;
  return data;
};

export const restoreCustomer = async ({ params }) => {
  const response = API.put(`/organization/customers/${params.id}/restore`);
  const data = await response;
  return data;
};

export const uploadCustomerMedia = async ({
  params,
  body,
  onUploadProgress,
}) => {
  const response = API.post(
    `/organization/customers/${params.id}/media`,
    body,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress,
      timeout: 120000,
    }
  );
  const data = await response;
  return data;
};

export const deleteCustomerMedia = async ({ params }) => {
  const response = API.delete(
    `/organization/customers/${params.id}/media/${params.media}`
  );
  const data = await response;
  return data;
};

/* Notes are plain comments on the customer, the same rows a task comment uses,
 * so they carry an author and attachments without a table of their own. */
export const createCustomerNote = async ({ params, body }) => {
  const response = API.post(`/organization/customers/${params.id}/notes`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  const data = await response;
  return data;
};

export const deleteCustomerNote = async ({ params }) => {
  const response = API.delete(
    `/organization/customers/${params.id}/notes/${params.note}`
  );
  const data = await response;
  return data;
};

export const completeCustomerNote = async ({ params }) => {
  const response = API.post(
    `/organization/customers/${params.id}/notes/${params.note}/done`
  );
  const data = await response;
  return data;
};

/* نمایندگان مشتری — کسانی که در آن شرکت با آن‌ها طرفیم. نماینده یک حساب کاربری
 * نیست؛ اکثرشان هیچ‌وقت وارد سیستم نمی‌شوند. */
export const createCustomerContact = async ({ params, body }) => {
  const response = API.post(
    `/organization/customers/${params.id}/contacts`,
    body
  );
  const data = await response;
  return data;
};

export const updateCustomerContact = async ({ params, body }) => {
  const response = API.patch(
    `/organization/customers/${params.id}/contacts/${params.contact}`,
    body
  );
  const data = await response;
  return data;
};

export const deleteCustomerContact = async ({ params }) => {
  const response = API.delete(
    `/organization/customers/${params.id}/contacts/${params.contact}`
  );
  const data = await response;
  return data;
};

/* پرتال مشتری: شیر اصلی و اینکه کدام پروژه‌ها برای مشتری دیده شوند. */
export const saveCustomerPortalAccess = async ({ params, body }) => {
  const response = API.patch(
    `/organization/customers/${params.id}/portal`,
    body
  );
  const data = await response;
  return data;
};

export const inviteCustomerContact = async ({ params }) => {
  const response = API.post(
    `/organization/customers/${params.id}/contacts/${params.contact}/invite`
  );
  const data = await response;
  return data;
};

export const revokeCustomerContact = async ({ params }) => {
  const response = API.delete(
    `/organization/customers/${params.id}/contacts/${params.contact}/invite`
  );
  const data = await response;
  return data;
};
